import axios from 'axios'
import store from '@/store'
async function getPartnerRules(partnerId) {
    try {
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/clients/v1/partner/rules/${partnerId}`, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            }
        })
        return result.data.payload
    } catch (e) {
        return e.response
    }

}

export default getPartnerRules